module.exports = __webpack_public_path__ + "static/img/brees-2014-slide-2.f653974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-slide-2.jpg
// module id = /4gt
// module chunks = 1